var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',{attrs:{"small":"","card":""}},[_c('custom-o-j-t-page',{attrs:{"active":""}}),_c('custom-m-a-page')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }